// A source whose result page lives outside this webview (e.g. the website: kanggo.id/thank-you) is sent there.
// The app source points at this webview's own /v2/success, which the app intercepts, so it keeps the old flow.
export const isExternalUrl = (url) => {
  if (!url) return false;
  try {
    return new URL(url).origin !== window.location.origin;
  } catch (e) {
    return false;
  }
};
